(function () {
  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return [].slice.call((root || document).querySelectorAll(selector)); }

  var menu = qs('#mobileNav');
  var menuButton = qs('#menuBtn');
  var menuDesktopQuery = window.matchMedia ? window.matchMedia('(min-width: 921px)') : null;
  var previousBodyOverflow = '';
  function menuFocusable() { return menu ? qsa('a,button,[tabindex]:not([tabindex="-1"])', menu) : []; }
  function closeMenu(restoreFocus) {
    if (!menu || !menu.classList.contains('open')) return;
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    menu.setAttribute('inert', '');
    qsa('details[open]', menu).forEach(function (details) { details.removeAttribute('open'); });
    document.body.style.overflow = previousBodyOverflow;
    if (menuButton) {
      menuButton.classList.remove('open');
      menuButton.setAttribute('aria-expanded', 'false');
      if (restoreFocus !== false) menuButton.focus();
    }
  }
  function openMenu() {
    if (!menu || !menuButton) return;
    previousBodyOverflow = document.body.style.overflow;
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    menu.removeAttribute('inert');
    menuButton.classList.add('open');
    menuButton.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var closeControl = qs('.mob-close', menu);
    window.requestAnimationFrame(function () {
      if (closeControl) closeControl.focus();
    });
  }
  if (menuButton && menu) menuButton.addEventListener('click', function () {
    if (menu.classList.contains('open')) closeMenu();
    else openMenu();
  });
  var closeButton = qs('.mob-close', menu); if (closeButton) closeButton.addEventListener('click', closeMenu);
  var overlay = qs('.mobile-overlay', menu); if (overlay) overlay.addEventListener('click', closeMenu);
  qsa('a', menu).forEach(function (link) { link.addEventListener('click', function () { closeMenu(false); }); });
  if (menuDesktopQuery) menuDesktopQuery.addEventListener('change', function (event) {
    if (event.matches) closeMenu(false);
  });
  document.addEventListener('keydown', function (event) {
    if (!menu || !menu.classList.contains('open')) return;
    if (event.key === 'Escape') { event.preventDefault(); closeMenu(); }
    if (event.key === 'Tab') {
      var focusable = menuFocusable();
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  var desktopNavDetails = qsa('.nav > details');
  desktopNavDetails.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      desktopNavDetails.forEach(function (otherDetails) {
        if (otherDetails !== details) otherDetails.removeAttribute('open');
      });
    });
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('.nav')) return;
    desktopNavDetails.forEach(function (details) { details.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    desktopNavDetails.forEach(function (details) {
      if (!details.open) return;
      details.removeAttribute('open');
      var summary = qs('summary', details);
      if (summary) summary.focus();
    });
  });

  var topButton = qs('#scrollTop');
  if (topButton) { window.addEventListener('scroll', function () { topButton.classList.toggle('show', window.scrollY > 600); }, { passive: true }); topButton.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }); }

  var ugcSlider = qs('#ugcSlider');
  if (ugcSlider) {
    qsa('.slider-nav button[data-dir]').forEach(function (button) {
      button.addEventListener('click', function () {
        var tile = qs('.social-tile', ugcSlider);
        var distance = tile ? tile.getBoundingClientRect().width + 14 : ugcSlider.clientWidth * 0.8;
        ugcSlider.scrollBy({ left: Number(button.dataset.dir) * distance, behavior: 'smooth' });
      });
    });
  }

  qsa('.quick-product-form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = qs('button', form); var original = button.textContent;
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(qs('[name="id"]', form).value), quantity: 1 }] }) })
        .then(function (response) { if (!response.ok) throw new Error('Cart error'); return response.json(); })
        .then(function () { button.textContent = '✓ Added'; return fetch(window.Shopify.routes.root + 'cart.js'); })
        .then(function (response) { return response.json(); }).then(function (cart) { qsa('.cart-badge').forEach(function (badge) { badge.textContent = cart.item_count; }); })
        .catch(function () { button.textContent = 'Try again'; })
        .finally(function () { window.setTimeout(function () { button.textContent = original; }, 1400); });
    });
  });

  var lazyVideos = qsa('video.lazy-video[data-src]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  function loadVideo(video) {
    if (video.src) return;
    video.src = video.dataset.src;
    video.removeAttribute('data-src');
    video.load();
    video.play().catch(function () {});
  }
  if (!reduceMotion && !saveData && 'IntersectionObserver' in window) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { loadVideo(entry.target); entry.target.play().catch(function () {}); }
        else if (entry.target.src) entry.target.pause();
      });
    }, { rootMargin: '0px', threshold: 0.15 });
    lazyVideos.slice(0, 3).forEach(function (video) { videoObserver.observe(video); });
  }

  document.addEventListener('click', function (event) {
    var playButton = event.target.closest('[data-tiktok-player-url]');
    if (!playButton) return;
    var card = playButton.closest('.bw-tiktok-card');
    if (!card || card.dataset.tiktokState === 'loading' || card.dataset.tiktokState === 'ready') return;
    var label = playButton.querySelector('[data-tiktok-label]');
    var status = card.querySelector('[data-tiktok-status]');
    var iframe = document.createElement('iframe');
    var loadTimer;

    card.dataset.tiktokState = 'loading';
    card.classList.add('is-player-loading');
    playButton.disabled = true;
    playButton.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Loading TikTok…';
    if (status) status.textContent = 'Loading TikTok video';

    function showPlayer() {
      window.clearTimeout(loadTimer);
      card.dataset.tiktokState = 'ready';
      card.classList.remove('is-player-loading');
      card.classList.add('is-player-ready');
      playButton.removeAttribute('aria-busy');
      if (status) status.textContent = 'TikTok video loaded. Press play in the video player.';
    }

    function restorePoster() {
      window.clearTimeout(loadTimer);
      iframe.remove();
      delete card.dataset.tiktokState;
      card.classList.remove('is-player-loading');
      playButton.disabled = false;
      playButton.removeAttribute('aria-busy');
      if (label) label.textContent = 'Try loading TikTok again';
      if (status) status.textContent = 'TikTok could not load. You can try again.';
    }

    iframe.className = 'bw-tiktok-card__player';
    iframe.src = playButton.dataset.tiktokPlayerUrl;
    iframe.title = playButton.dataset.tiktokTitle || 'Brushworks TikTok video';
    iframe.loading = 'eager';
    iframe.allow = 'fullscreen; encrypted-media; picture-in-picture';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.setAttribute('allowfullscreen', '');
    iframe.addEventListener('load', showPlayer, { once: true });
    iframe.addEventListener('error', restorePoster, { once: true });
    card.appendChild(iframe);
    loadTimer = window.setTimeout(restorePoster, 15000);
  });

  function hydrateDeferredImage(image) {
    if (!image || image.dataset.bwDeferredReady === 'true') return Promise.resolve();
    image.dataset.bwDeferredReady = 'true';
    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      image.removeAttribute('data-srcset');
    }
    if (image.dataset.src) {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    }
    if (typeof image.decode === 'function') return image.decode().catch(function () {});
    return new Promise(function (resolve) {
      if (image.complete) resolve();
      else {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      }
    });
  }

  function prepareCommunityGallery(track) {
    if (!track || track.dataset.galleryReady === 'true') return;
    var original = qs('[data-community-gallery-set]', track);
    if (!original) return;
    Promise.all(qsa('img[data-bw-deferred-image]', original).map(hydrateDeferredImage)).then(function () {
      if (track.dataset.galleryReady === 'true') return;
      var duplicate = original.cloneNode(true);
      duplicate.removeAttribute('data-community-gallery-set');
      duplicate.setAttribute('aria-hidden', 'true');
      qsa('img', duplicate).forEach(function (image) {
        image.alt = '';
        image.setAttribute('aria-hidden', 'true');
      });
      track.appendChild(duplicate);
      track.dataset.galleryReady = 'true';
      track.classList.add('is-ready');
    });
  }

  var communityTracks = qsa('[data-community-gallery-track]');
  if (communityTracks.length && 'IntersectionObserver' in window) {
    var communityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        communityObserver.unobserve(entry.target);
        prepareCommunityGallery(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    communityTracks.forEach(function (track) { communityObserver.observe(track); });
  } else {
    window.addEventListener('load', function () {
      communityTracks.forEach(prepareCommunityGallery);
    }, { once: true });
  }

  var isHomepage = document.body.classList.contains('template-index');
  if (isHomepage && !reduceMotion) {
    var homeRevealGroups = qsa([
      '.bw-featured-products',
      '.bw-category-section',
      '.sf-pink-shelf',
      '.sf-finish',
      '.sf-pretty',
      '.sf-feel-good'
    ].join(','));
    var homeRevealSelector = [
      '.bw-section-heading > *',
      '.bw-featured-products__item',
      '.bw-category-card',
      '.sf-pink-shelf__copy > *',
      '.sf-pink-shelf__product',
      '.sf-finish__intro > *',
      '.sf-finish__list > *',
      '.sf-finish__preview',
      '.sf-pretty__image',
      '.sf-pretty__copy > *',
      '.sf-feel-good__image',
      '.sf-feel-good__copy > *'
    ].join(',');

    homeRevealGroups.forEach(function (group) {
      qsa(homeRevealSelector, group).forEach(function (item, index) {
        var revealKind = item.matches('.sf-pretty__image, .sf-feel-good__image, .sf-finish__preview') ? 'media' : 'item';
        item.dataset.bwHomeReveal = revealKind;
        item.style.setProperty('--bw-home-reveal-delay', Math.min(index, 7) * 65 + 'ms');
      });
    });

    if (homeRevealGroups.length) document.documentElement.classList.add('bw-home-motion-ready');
    if ('IntersectionObserver' in window) {
      var homeRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-bw-home-visible');
          homeRevealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      homeRevealGroups.forEach(function (group) { homeRevealObserver.observe(group); });
    } else {
      homeRevealGroups.forEach(function (group) { group.classList.add('is-bw-home-visible'); });
    }

    [

      ['.sf-pink-shelf__product', 8, 1.5],
      ['.sf-finish__preview', 10, 2],
      ['.sf-pretty__image', 14, 3],
      ['.sf-feel-good__image', 14, 3],
      ['.bw-signup__media', 12, 3]
    ].forEach(function (config) {
      qsa(config[0]).forEach(function (item) {
        item.setAttribute('data-bw-parallax', '');
        item.dataset.bwParallaxStrength = config[1];
        item.dataset.bwScrollZoom = config[2];
      });
    });
  }
  var desktopMotion = window.matchMedia && window.matchMedia('(min-width: 921px)').matches;
  if (!reduceMotion && desktopMotion) {
    var parallaxTicking = false;
    var parallaxItems = qsa('[data-bw-parallax]');
    function updateParallax() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      parallaxItems.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var strength = Math.max(0, Number(item.dataset.bwParallaxStrength) || 0);
        var zoomAmount = Math.max(0, Number(item.dataset.bwScrollZoom) || 0) / 100;
        var travel = viewportHeight / 2 + rect.height / 2;
        var progress = (viewportHeight / 2 - (rect.top + rect.height / 2)) / travel;
        var clampedProgress = Math.max(-1, Math.min(1, progress));
        var zoomProgress = (clampedProgress + 1) / 2;
        var offset = clampedProgress * strength;
        var scale = 1 + (zoomProgress * zoomAmount);
        item.style.setProperty('--bw-parallax-y', offset.toFixed(2) + 'px');
        item.style.setProperty('--bw-parallax-scale', scale.toFixed(4));
      });
      parallaxTicking = false;
    }
    function requestParallaxUpdate() {
      if (parallaxTicking) return;
      parallaxTicking = true;
      window.requestAnimationFrame(updateParallax);
    }
    if (parallaxItems.length) {
      window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
      window.addEventListener('resize', requestParallaxUpdate);
      window.addEventListener('pageshow', requestParallaxUpdate);
      document.addEventListener('shopify:section:load', requestParallaxUpdate);
      document.addEventListener('shopify:section:reorder', requestParallaxUpdate);
      requestParallaxUpdate();
    }
  }

  /* Footer logo grows into its existing full size as the footer enters view. */
  if (!reduceMotion) {
    var footerLogo = qs('.footer-hero-logo');
    var footerLogoFrame = null;
    function updateFooterLogo() {
      if (!footerLogo) return;
      var footer = footerLogo.closest('.footer');
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var rect = (footer || footerLogo).getBoundingClientRect();
      var progress = Math.max(0, Math.min(1, (viewportHeight - rect.top) / (viewportHeight * .78)));
      var scale = .72 + (progress * .28);
      var offset = (1 - progress) * 34;
      footerLogo.style.setProperty('--bw-footer-logo-scale', scale.toFixed(4));
      footerLogo.style.setProperty('--bw-footer-logo-y', offset.toFixed(2) + 'px');
      footerLogoFrame = null;
    }
    function requestFooterLogoUpdate() {
      if (footerLogoFrame) return;
      footerLogoFrame = window.requestAnimationFrame(updateFooterLogo);
    }
    if (footerLogo) {
      window.addEventListener('scroll', requestFooterLogoUpdate, { passive: true });
      window.addEventListener('resize', requestFooterLogoUpdate);
      window.addEventListener('pageshow', requestFooterLogoUpdate);
      document.addEventListener('shopify:section:load', requestFooterLogoUpdate);
      document.addEventListener('shopify:section:reorder', requestFooterLogoUpdate);
      requestFooterLogoUpdate();
    }
  }

  qsa('[data-bw-sticky-add]').forEach(function (button) {
    button.addEventListener('click', function () {
      var target = qs('[data-bw-add]');
      if (target && !target.disabled) target.click();
    });
  });

  var faqSearch = qs('[data-faq-search]');
  if (faqSearch) {
    faqSearch.addEventListener('input', function () {
      var term = faqSearch.value.trim().toLowerCase();
      qsa('.bw-faq-list details').forEach(function (item) {
        item.hidden = term && item.textContent.toLowerCase().indexOf(term) === -1;
      });
    });
  }

  document.addEventListener('shopify:section:load', function () { window.location.reload(); });
})();
